



import React, { useState } from "react";

const Gallery = () => {
  const images = [
    { id: 17, src: "/images/gallery/48.jpeg", alt: "50 Seater" },
    { id: 20, src: "/images/gallery/444.jpeg", alt: "50 Seater" },
    { id: 1, src: "/images/gallery/23.jpeg", alt: "50 Seater" },
    { id: 2, src: "/images/gallery/20.jpeg", alt: "50 Seater" },
    { id: 3, src: "/images/gallery/38.jpeg", alt: "50 Seater" },
    { id: 5, src: "/images/gallery/28.jpeg", alt: "50 Seater" },
    { id: 6, src: "/images/gallery/30.jpeg", alt: "50 Seater" },
    { id: 7, src: "/images/gallery/31.jpeg", alt: "50 Seater" },
    { id: 8, src: "/images/gallery/32.jpeg", alt: "50 Seater" },
    { id: 9, src: "/images/gallery/34.jpeg", alt: "50 Seater" },
    { id: 10, src: "/images/gallery/35.jpeg", alt: "50 Seater" },
    { id: 11, src: "/images/gallery/36.jpeg", alt: "50 Seater" },
    { id: 13, src: "/images/gallery/40.jpeg", alt: "50 Seater" },
    { id: 14, src: "/images/gallery/41.jpeg", alt: "50 Seater" },
    { id: 15, src: "/images/gallery/46.jpeg", alt: "50 Seater" },
    { id: 16, src: "/images/gallery/47.jpeg", alt: "50 Seater" },
    { id: 18, src: "/images/gallery/42.jpeg", alt: "50 Seater" },
     { id: 12, src: "/images/gallery/56.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/57.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/58.jpeg", alt: "50 Seater" },
    // { id: 12, src: "/images/gallery/59.jpeg", alt: "50 Seater" },
    { id: 19, src: "/images/gallery/43.jpeg", alt: "50 Seater" },
    { id: 21, src: "/images/gallery/45.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/37.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/51.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/52.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/53.jpeg", alt: "50 Seater" },
    // { id: 12, src: "/images/gallery/54.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/55.jpeg", alt: "50 Seater" },
   
    // { id: 12, src: "/images/gallery/60.jpeg", alt: "50 Seater" },
    { id: 12, src: "/images/gallery/61.jpeg", alt: "50 Seater" },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const nextImage = () =>
    setCurrentImageIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );

  const prevImage = () =>
    setCurrentImageIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );

  return (
    <>
      {/* PAGE HEADER */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Gallery
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

<div className="row p-3">

<div className="col-12 col-md-6">
      {/* VIDEO SECTION (YOUR SAME VIDEO) */}
      <div
        style={{
          maxWidth: "900px",
          margin: "50px auto",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
        }}
      >
        <iframe
          width="100%"
          height="450"
          src="https://www.youtube.com/embed/Dv8hwIU3wjw?autoplay=1&mute=1&loop=1&playlist=Dv8hwIU3wjw&controls=1&rel=0&modestbranding=1"
          title="Aaryan Travels Gallery Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>




</div>




<div className="col-12 col-md-6">

       <div
        style={{
          maxWidth: "900px",
          margin: "50px auto",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
        }}
      >
     <iframe width="100%" height="450" src="https://www.youtube.com/embed/WbBW3B5_VMc?si=xSUHbVlvwt2Qq7Lx" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>

</div>


<div className="col-12 col-md-6">
  <div
    style={{
      maxWidth: "900px",
      margin: "50px auto",
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
    }}
  >
    <iframe
      width="100%"
      height="450"
      src="https://www.youtube.com/embed/XZrNtw_Qz_E?autoplay=1&mute=1&loop=1&playlist=XZrNtw_Qz_E&controls=1&rel=0&modestbranding=1"
      title="Aaryan Travels Gallery Video"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>
</div>




</div>

      {/* IMAGE GALLERY */}
      <div className="gallery-container">
        <div className="gallery-grid">
          {images.map((image, index) => (
            <img
              key={image.id}
              src={image.src}
              alt={image.alt}
              className="gallery-image-item"
              onClick={() => openModal(index)}
            />
          ))}
        </div>

        {/* MODAL */}
        {isModalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div
              className="modal-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="modal-close-button" onClick={closeModal}>
                &times;
              </button>

              <button className="modal-prev-button" onClick={prevImage}>
                &#10094;
              </button>

              <div className="modal-image-container">
                <img
                  src={images[currentImageIndex].src}
                  alt=""
                  className="modal-image"
                />
              </div>

              <button className="modal-next-button" onClick={nextImage}>
                &#10095;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Gallery;


